import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SearchState, FilterState } from '../models/browser.model';
import { Core, ApplicationConfiguration, Address, QueryParamService } from '../shared/core/ovs.core';
import { ResortApplicationConfiguration, ResortImage, ResortDetail, ResortInventory, ResortBooking, BookingResult } from '../models/presentation.model';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CookieService } from '@ngx-toolkit/cookie';
import { StorageService } from './storage-service.client';
import { shareReplay } from 'rxjs/operators';

export abstract class ResortApplicationBase 
{
    public abstract get searchState(): SearchState;
    public abstract set searchState(value: SearchState);
    public abstract get configuration(): ResortApplicationConfiguration;
    public abstract checkOut(resort: ResortDetail, inventory: ResortInventory, withUpgrade?: boolean): void;
    public abstract initiatecheckOut(resort: ResortDetail, inventory: ResortInventory, withUpgrade?: boolean): void;
    public abstract get currentBooking(): ResortBooking;
    public abstract set currentBooking(value: ResortBooking);
    public abstract get currentResort(): ResortDetail;
    public abstract get currentInventory(): ResortInventory;
    public abstract getImageUrl(image: ResortImage): string;
    public abstract get bookingCompletion(): BookingResult;
    public abstract set bookingCompletion(value: BookingResult);
    public abstract getSafeUrl(image: ResortImage): SafeResourceUrl;
}

@Injectable()
export class ResortApplication extends ResortApplicationBase
{
    private _booking: BehaviorSubject<ResortBooking> = new BehaviorSubject<ResortBooking>(null);
    private _router: Router;
    private _core: Core;
    private _currentResort: ResortDetail;
    private _currentInventory: ResortInventory;
    private _bookingCompletion: BookingResult;
    private _searchState: SearchState;
    private _sanitizer: DomSanitizer;
    private _disclaimerURL = 'assets/disclaimerText.json';

    constructor(
        router: Router, 
        core: Core, 
        sanitizer: DomSanitizer, 
        private cookieService: CookieService, 
        private storageService: StorageService, 
        private qryParamService: QueryParamService, 
        private http: HttpClient
    ) {
        super();
        this._router = router;
        this._core = core;
        this._sanitizer = sanitizer;
    }

    public get searchState(): SearchState { return this._searchState; }
    public set searchState(value: SearchState) { this._searchState = value; }
    public get configuration(): ResortApplicationConfiguration { return <ResortApplicationConfiguration>this._core.currentConfiguration; }
    public get currentBooking(): ResortBooking { return this._booking.value; }
    public set currentBooking(value: ResortBooking) { this._booking.next(value); }
    public get currentResort(): ResortDetail { return this._currentResort; }
    public get currentInventory(): ResortInventory { return this._currentInventory; }
    public get bookingCompletion(): BookingResult { return this._bookingCompletion; }
    public set bookingCompletion(value: BookingResult) { this._bookingCompletion = value; }

    public iterator(count: number): any[]
    {
        return [...Array(count)];
    }

    public getImageUrl(image: ResortImage): string
    {
        if (image.imagePath == -1)
            return image.fileName;

        let path: string = this.configuration.ImageRootUrls.where(i => i.Id == image.imagePath)
            .firstOrDefault().ImagePathRoot; 
            
        if (!path.endsWithStr("/"))
            path += "/";

        return path + image.fileName;
    }

    public getSafeUrl(image: ResortImage): SafeResourceUrl
    {
        let url: string = image.fileName;

        if (image.imagePath >= 0)
        {
            let path: string = this.configuration.ImageRootUrls.where(i => i.Id == image.imagePath)
            .firstOrDefault().ImagePathRoot;
        
            if (!path.endsWithStr("/"))
                path += "/";

            url = path + image.fileName;
        }

        return this._sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    public checkOut(resort: ResortDetail, inventory: ResortInventory, withUpgrade?: boolean): void
    {
        this.qryParamService.checkoutParams.inventoryId = inventory.id;
        this.qryParamService.checkoutParams.intervalId = inventory.intervalId;
        this.qryParamService.store();
        this.initiatecheckOut(resort, inventory, withUpgrade);
        this._router.navigate(["check-out"], { queryParams: { sid: this.qryParamService.encodedGuid}});
    }

    public initiatecheckOut(resort: ResortDetail, inventory: ResortInventory, withUpgrade?: boolean):void{
        this._currentInventory = inventory;
        this._currentResort = resort;
        let booking: ResortBooking = new ResortBooking();
        booking.Address = new Address();
        booking.IsUpgradeMembershipSelected = withUpgrade ? true: false;
        console.log(booking.IsUpgradeMembershipSelected ? 'Upgrade Membershp Booking': 'Normal Booking')
        this._booking.next(booking);
    }

    public getDisclaimer(): Observable<any> {
        return this.http.get(this._disclaimerURL).pipe(shareReplay());
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/resort-application.service.ts